export const serviceVisitBoardTasksMixin = {
  methods: {
    updateTaskItem({ visitId, item }) {
      const visit = this.visits.find(item => item.id === visitId);

      if (!visit) {
        return;
      }

      const taskIndex = (visit.items || []).findIndex(visitItem => visitItem.id === item.id);

      if (taskIndex >= 0) {
        this.$set(visit.items, taskIndex, item);
        this.showTaskUpdatedToast();
      }
    },
    addTaskItem({ visitId, item }) {
      const visit = this.visits.find(item => item.id === visitId);

      if (!visit) {
        return;
      }

      if (!visit.items) {
        this.$set(visit, "items", []);
      }

      visit.items.push(item);
      this.showTaskCreatedToast();
    },
    replaceTaskItems({ visitId, items }) {
      const visit = this.visits.find(item => item.id === visitId);

      if (!visit) {
        return;
      }

      this.$set(visit, "items", items || []);
      this.showTasksReorderedToast();
    },
    showTaskUpdatedToast() {
      this.showBoardToast("success", "flaticon2-checkmark", this.$t("SERVICE_VISITS.TASK_UPDATED"));
    },
    showTaskCreatedToast() {
      this.showBoardToast("success", "flaticon2-checkmark", this.$t("SERVICE_VISITS.TASK_CREATED"));
    },
    showTasksReorderedToast() {
      this.showBoardToast("success", "flaticon2-checkmark", this.$t("SERVICE_VISITS.TASKS_REORDERED"));
    },
    showBoardToast(type, icon, text) {
      if (!this.$notify) {
        return;
      }

      this.$notify({
        group: "notify",
        type,
        title: `<i class='${icon}'></i> ${this.$t("ALERTS.SUCCESS")}`,
        text
      });
    }
  }
};
